import { getSportContext } from '../onboarding/sportContext';
import i18n from '../i18n';

export function getDemoTourSteps(sportTypeId, stats = {}) {
  const ctx = getSportContext(sportTypeId);
  const s = ctx.student;
  const g = ctx.group;
  const totalStudents = stats.totalStudents ?? 20;
  const totalGroups = stats.totalGroups ?? 4;
  const monthRevenue = stats.monthRevenue ?? 87000;
  const debtors = stats.debtors ?? 4;
  const pendingApplications = stats.pendingApplications ?? 3;
  const confirmed = stats.nextLesson?.confirmedCount ?? 12;
  const studentsCount = stats.nextLesson?.studentsCount ?? 16;
  const activeRentals = stats.activeRentals ?? 2;
  const isFootball = ctx.sportEmoji === '⚽';

  return [
    {
      target: '[data-onboarding="school-name"]',
      title: i18n.t('demoTour:schoolTitle'),
      content: isFootball
        ? i18n.t('demoTour:schoolContentFootball', { emoji: ctx.sportEmoji, students: s })
        : i18n.t('demoTour:schoolContentSport', { emoji: ctx.sportEmoji, students: s }),
      disableBeacon: true
    },
    {
      target: '[data-onboarding="dashboard-metrics"]',
      title: i18n.t('demoTour:metricsTitle'),
      content: i18n.t('demoTour:metricsContent', {
        students: totalStudents,
        studentsLabel: s,
        groups: totalGroups,
        groupsLabel: g,
        revenue: monthRevenue.toLocaleString('ru-RU'),
        debtors
      }),
      disableBeacon: true
    },
    {
      target: '[data-onboarding="nav-schedule"]',
      title: i18n.t('demoTour:scheduleTitle'),
      content: i18n.t('demoTour:scheduleContent'),
      disableBeacon: true
    },
    {
      target: '[data-onboarding="next-lesson-card"]',
      title: i18n.t('demoTour:nextLessonTitle'),
      content: i18n.t('demoTour:nextLessonContent', {
        confirmed,
        total: studentsCount,
        studentsLabel: s,
        groupsLabel: g
      }),
      disableBeacon: true
    },
    {
      target: '[data-onboarding="nav-students"]',
      title: i18n.t('demoTour:studentsTitle', { studentsTitle: s.charAt(0).toUpperCase() + s.slice(1) }),
      content: i18n.t('demoTour:studentsContent', { studentsLabel: s }),
      disableBeacon: true
    },
    {
      target: '[data-onboarding="nav-applications"]',
      title: i18n.t('demoTour:applicationsTitle'),
      content: i18n.t('demoTour:applicationsContent', {
        count: pendingApplications,
        studentsLabel: s,
        coachesLabel: ctx.coach
      }),
      disableBeacon: true
    },
    {
      target: '[data-onboarding="nav-finance"]',
      title: i18n.t('demoTour:financeTitle'),
      content: i18n.t('demoTour:financeContent', {
        revenue: monthRevenue.toLocaleString('ru-RU')
      }),
      disableBeacon: true
    },
    {
      target: '[data-onboarding="nav-inventory"]',
      title: i18n.t('demoTour:inventoryTitle'),
      content: i18n.t('demoTour:inventoryContent', {
        studentsLabel: s,
        rentals: activeRentals
      }),
      disableBeacon: true
    }
  ];
}
